import { List as RadixTabList } from '@radix-ui/react-tabs';
import type { TabsListProps as RadixTabsListProps } from '@radix-ui/react-tabs';
import { styled } from 'styled-components';
import type { JSX, PropsWithChildren } from 'react';
import { segmentedControlStyles } from '../SegmentedControl/SegmentedControl';
import { SelectedTabIndicator } from './SelectedTabIndicator';

export type TabsListProps = Pick<RadixTabsListProps, 'aria-label'> &
  PropsWithChildren<{
    fullWidth?: boolean;
  }>;

const StyledTabsList = styled(RadixTabList)<{ $fullWidth: boolean }>`
  ${segmentedControlStyles}
`;

export const TabsList = ({ children, fullWidth = true, ...props }: TabsListProps): JSX.Element => {
  return (
    <StyledTabsList
      $fullWidth={fullWidth}
      aria-label={props['aria-label']}
    >
      {children}
      <SelectedTabIndicator />
    </StyledTabsList>
  );
};

TabsList.displayName = 'TabsList';
